<template>
  <div class="d-flex">
    <b-button variant="flat-primary" v-if="podeEditar" @click="editar">
      <i class="fas fa-edit"></i>
    </b-button>
    <b-button variant="flat-danger" v-if="podeExcluir" @click="excluir">
      <i class="fas fa-trash"></i>
    </b-button>
  </div>
</template>
<script>
export default {
  props: {
    podeEditar: {
      default: true,
    },
    podeExcluir: {
      default: true,
    },
  },
  methods: {
    editar: function () {
      this.$emit("editar");
    },
    excluir: function () {
      this.$emit("excluir");
    },
  },
};
</script>
<style lang=""></style>
